export const USER_GET = 'USER_GET'
export const USER_SET = 'USER_SET'
export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
